<template>
  <v-container fluid class="pa-2" style="margin-top: 2%; max-width: 100%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                $t("button.dismiss") }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                $t("button.confirm") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="showExportRoutesDialog" max-width="900" persistent>
        <v-card>
            <v-card-title>{{ $t('routePlanning.dialogs.exportRoutes.title') }}</v-card-title>
            <v-card-text>
                <div class="text-caption text--secondary mb-2">
                    {{ $t('routePlanning.dialogs.exportRoutes.formatLabel') }}
                </div>
                <v-radio-group v-model="exportRoutesFormat" hide-details class="mt-0 pt-0">
                    <v-radio
                        :label="$t('routePlanning.dialogs.exportRoutes.formatGeojson')"
                        value="geojson"
                    ></v-radio>
                    <v-radio
                        :label="$t('routePlanning.dialogs.exportRoutes.formatKml')"
                        value="kml"
                    ></v-radio>
                </v-radio-group>
                <div class="text-caption text--secondary mt-4 mb-2">
                    {{ $t('routePlanning.dialogs.exportRoutes.selectRoutesLabel') }}
                </div>
                <merus-data-table
                    :headers="exportDialogHeaders"
                    :items="rotasForExportDialog"
                    :loading="loadingExportDialog"
                    :default-multi-sort="defaultSort"
                    :loading-text="$t('routs.loading')"
                    :show-select="true"
                    item-key="id_rota"
                    v-model="rotasSelected"
                    hide-sort-button
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeExportRoutesDialog">{{ $t('button.cancel') }}</v-btn>
                <v-btn
                    color="primary"
                    dark
                    :disabled="rotasSelected.length === 0"
                    @click="onConfirmExportRoutes"
                >
                    {{ $t('button.export') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <recursos-operacionais-split-layout
      ref="detalheSplit"
      :linha="linhaSelecionada"
      preview-type="route"
      :preview-item="rotaSelecionada"
      :preview-items="selecionadas"
      :initial-tab="initialDetailTab"
      :preferred-route-ids="preferredRouteIds"
      :parametros-total="selecionadas.length"
      :parametros-page.sync="parametrosPage"
      :parametros-label="parametrosLabel"
      :token="token"
      :can-edit="canEditLinha"
      :can-insert="canInsert"
      @map-action="onMapAction"
      @preview-changed="onPreviewChanged"
      @parametros-save="saveParametros"
    >
      <template #parametros>
        <v-card-text>
          <v-container>
            <v-form ref="formParametros" v-model="formValidado">
              <v-row>
                <v-col cols="12" sm="6" md="2">
                  <v-autocomplete v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                    item-value="id_empresa" clearable :label="$t('area.selectCompany')"
                    :rules="[(v) => !!v || $t('company.companyRequired')]"
                    :disabled="isScopedClienteCreateLock"></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <v-autocomplete v-model="editedItem.id_cliente" :items="clientesFiltrados"
                    item-text="labelCliente" item-value="id_cliente" clearable
                    :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
                    :label="$t('routs.selectClient')"></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="editedItem.cod_rota" :label="$t('routs.code')"
                    :rules="[codRotaRules]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="editedItem.nome_rota" :label="$t('routs.name')"
                    :rules="[nomeRotaRules]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="editedItem.cod_integracao" :label="$t('routs.integrationCode')"
                    :rules="[codIntegracaoRules]" maxlength="50" clearable></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="1">
                  <v-text-field v-model="editedItem.distancia" :label="$t('routs.distance')" min="0"
                    hide-spin-buttons></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="1">
                  <v-switch v-model="isAtivo" class="ma-2" :label="$tc('geofence.active', 1)"></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-textarea clearable clear-icon="mdi-close-circle" v-model="editedItem.observacoes"
                    :label="$t('routs.observations')" :rules="[observacoesRules]" rows="1">
                  </v-textarea>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-file-input show-size accept=".geojson" :label="$t('routs.selectGeojsonArchive')" :rules="[geojsonRules]"
                    v-model="arquivoGeojson"></v-file-input>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" dark fab small v-bind="attrs" v-on="on" @click="processaGeojson">
                        <v-icon dark>mdi-map-marker-down</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('routs.processGeojson') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </template>
      <template #create-entity>
        <v-form ref="formCreate" v-model="formValidado" class="pa-2">
          <v-autocomplete
            v-model="editedItem.id_empresa"
            :items="empresas"
            item-text="razao_social"
            item-value="id_empresa"
            clearable
            dense
            outlined
            :label="$t('area.selectCompany')"
            :rules="createValidationAttempted ? [(v) => !!v || $t('company.companyRequired')] : []"
            :disabled="isScopedClienteCreateLock"
          />
          <v-autocomplete
            v-model="editedItem.id_cliente"
            :items="clientesFiltrados"
            item-text="labelCliente"
            item-value="id_cliente"
            clearable
            dense
            outlined
            :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
            :label="$t('routs.selectClient')"
            class="mb-2"
          />
          <v-text-field
            v-model="editedItem.cod_rota"
            :label="$t('routs.code')"
            :rules="createValidationAttempted ? [codRotaRules] : []"
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.nome_rota"
            :label="$t('routs.name')"
            :rules="createValidationAttempted ? [nomeRotaRules] : []"
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.cod_integracao"
            :label="$t('routs.integrationCode')"
            :rules="createValidationAttempted ? [codIntegracaoRules] : []"
            maxlength="50"
            clearable
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.distancia"
            :label="$t('routs.distance')"
            min="0"
            hide-spin-buttons
            dense
            outlined
            class="mb-2"
          />
          <v-switch
            v-model="isAtivo"
            class="mt-0 mb-2"
            hide-details
            :label="$tc('geofence.active', 1)"
          />
          <v-textarea
            clearable
            clear-icon="mdi-close-circle"
            v-model="editedItem.observacoes"
            :label="$t('routs.observations')"
            :rules="createValidationAttempted ? [observacoesRules] : []"
            dense
            outlined
            rows="2"
            class="mb-2"
          />
          <div class="mb-3">
            <div class="d-flex align-center flex-wrap mb-1">
              <v-btn
                small
                class="mr-2 mb-1"
                :color="desenhoRotaAtivo ? 'warning' : 'primary'"
                dark
                @click="toggleDesenhoRota"
              >
                <v-icon left small>mdi-vector-polyline</v-icon>
                {{ $t('crudLinhas.map.controls.drawRoute') }}
              </v-btn>
              <v-chip
                v-if="contagemVerticesRota > 0"
                x-small
                class="mr-2 mb-1"
                color="primary"
                text-color="white"
              >
                {{ $t('routs.routeLineDefined', { count: contagemVerticesRota }) }}
              </v-chip>
              <v-btn
                v-if="contagemVerticesRota > 0 || editedItem.geojson || editedItem.shape"
                x-small
                text
                class="mb-1"
                @click="limparGeometriaRotaFormulario"
              >
                {{ $t('button.clear') }}
              </v-btn>
            </div>
            <div v-if="createValidationAttempted && !editedItem.geojson && !editedItem.shape" class="caption red--text">
              {{ $t('routs.geometryRequired') }}
            </div>
          </div>
          <div class="d-flex align-center mb-2">
            <v-file-input
              show-size
              accept=".geojson"
              :label="$t('routs.selectGeojsonArchive')"
              :rules="createValidationAttempted ? [geojsonRules] : []"
              v-model="arquivoGeojson"
              dense
              outlined
              hide-details="auto"
              class="flex-grow-1"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  fab
                  x-small
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="processaGeojson"
                >
                  <v-icon small dark>mdi-map-marker-down</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('routs.processGeojson') }}</span>
            </v-tooltip>
          </div>
          <div class="d-flex justify-end pt-2">
            <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
              {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary darken-1" class="white--text" small @click="save">
              {{ $t('button.save') }}
            </v-btn>
          </div>
        </v-form>
      </template>
    <merus-data-table
      :headers="headers"
      :items="rotas"
      mostrar-inativos
      :loading="loadingtable"
      :default-multi-sort="defaultSort"
      :loading-text="$t('routs.loading')"
      :server-items-length="totalRotas"
      :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy"
      :server-sort-desc="serverSortDesc"
      @update:options="onTableOptions"
      @update:filters="onFiltersUpdate"
      item-key="id_rota"
      show-select
      v-model="selecionadas"
      cod-tabela="ROTAS"
      @update:headers="headers = $event"
    >
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('routs.title')" :token="token" :items="[]"
          :load-items-for-export="loadItemsForExport" background-export
          :export-filters="searchFilters" :export-sort-by="serverSortBy" :export-sort-desc="serverSortDesc"
          :export-total="totalRotas" :selected-ids="selectedRotasIds" id-field="id_rota"
          :csv-title="$t('routs.title')" :pdf-title="$t('routs.title')"
          :pdf-headers="headers" pdf-filename="rotas" hide-search
          :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvrotas/' : null" @saveBulk="saveBulk"
          :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$t('routs.title')" :csv-headers="headersCSV">
          <template v-slot:extension>
            <v-row>
              <v-col cols="12" sm="4" md="6">
                <v-switch
                  v-model="mostrarInativos"
                  :label="$t('crudVeiculos.showInactive')"
                  class="ml-3 mr-4"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="4" md="6" style="margin-top: 15px">
                <LazySelect
                  ref="linhaFiltroSelect"
                  get-url="getLinhaslazy"
                  text="nome_linha"
                  value="id_linha"
                  :label="$tc('line.self', 1)"
                  class="mr-4"
                  style="max-width: 320px;"
                  @input="onLinhaFiltroInput"
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:add>
            <v-tooltip v-if="canInsert" top>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark small class="mb-2 mr-2" fab v-on="on" @click="startCreateRota">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('routs.register') }}</span>
            </v-tooltip>
            <v-tooltip v-if="canInsert" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  @click="openExportRoutesDialog"
                  dark
                  fab
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mb-2 mr-2"
                  :disabled="!selecionadas.length"
                  :loading="loadingExportDialog"
                >
                  <v-icon dark color="white">mdi-export</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('routePlanning.actions.exportRoutes') }}</span>
            </v-tooltip>
            <ParseKmlDialog />
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="red" @click.stop="deleteItem(item)" :disabled="item.ativa === 0 || !canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>
    </recursos-operacionais-split-layout>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from "../utils/eventBus";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";
import ParseKmlDialog from "./Dialogs/ParseKmlDialog.vue";
import LazySelect from "./Selects/LazySelect.vue";
import RecursosOperacionaisSplitLayout from "./Linhas/RecursosOperacionaisSplitLayout.vue";
import { featureCollectionToKml } from "../utils/kmlLineAssistantGeo.js";
import { sameSelection, mergeSelectionWithPage, dropFromSelection, currentPageItem } from "@/utils/tableSelection";
import serverTableMixin from "@/mixins/serverTableMixin";
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    ParseKmlDialog,
    LazySelect,
    RecursosOperacionaisSplitLayout
  },
  mixins: [serverTableMixin],
  data: () => ({
    headers: [],
    user: null,
    token: null,
    totalRotas: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    rotasSelected: [],
    rotasExportDialogItems: [],
    loadingExportDialog: false,
    mostrarInativos: false,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    createValidationAttempted: false,
    operacao: 0,
    isAtivo: true,
    confirmDialog: false,
    showExportRoutesDialog: false,
    exportRoutesFormat: "geojson",
    mensagemdialog: "",
    loadingtable: true,
    arquivoGeojson: null,
    desenhoRotaAtivo: false,
    rotas: [],
    idLinhaSelected: null,
    empresas: [],
    clientes: [],
    editedIndex: -1,
    editedItem: {
      id_rota: null,
      cod_rota: null,
      nome_rota: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      ativa: null,
      ativa_extenso: null,
      observacoes: null,
      id_empresa: null,
      razao_social: null,
      distancia: null,
      id_cliente: null,
      nome_cliente: null,
    },
    deletedItem: {
      id_rota: null,
      cod_rota: null,
      nome_rota: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      ativa: null,
      ativa_extenso: null,
      observacoes: null,
      id_empresa: null,
      razao_social: null,
      distancia: null,
      id_cliente: null,
      nome_cliente: null,
    },
    defaultItem: {
      id_rota: null,
      cod_rota: null,
      nome_rota: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      ativa: null,
      ativa_extenso: null,
      observacoes: null,
      id_empresa: null,
      razao_social: null,
      distancia: null,
      id_cliente: null,
      nome_cliente: null,
    },
    recursos: [],
    permissoes: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    canEditLinha: false,
    linhaSelecionada: null,
    rotaSelecionada: null,
    selecionadas: [],
    parametrosPage: 0,
    initialDetailTab: 0,
    preferredRouteIds: [],
    scopedClienteCreateLocked: false,
  }),
  computed: {
    selectedRotasIds() {
      return (this.selecionadas || [])
        .map((r) => (r && r.id_rota != null ? r.id_rota : null))
        .filter((id) => id != null);
    },
    /** Rota exibida na página atual do paginador de parâmetros. */
    itemParametrosAtual() {
      return currentPageItem(this.selecionadas, this.parametrosPage);
    },
    parametrosLabel() {
      const item = this.itemParametrosAtual;
      if (!item) return null;
      return [item.cod_rota, item.nome_rota].filter(Boolean).join(" — ") || null;
    },
    defaultSort() {
      return [
        { value: 'ativa_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } },
        { value: 'cod_rota', options: { text: this.$t('routs.increasing'), value: 1 } }]
    },
    isScopedClienteCreateLock() {
      return this.editedIndex === -1 && this.scopedClienteCreateLocked;
    },
    codRotaRules() {
      if (!this.isCodRotaValid(this.editedItem.cod_rota)) {
        return this.$t('routs.rules.codeRequired');
      } else {
        return true;
      }
    },
    nomeRotaRules() {
      if (!validador(this.editedItem.nome_rota, 1, 200, 1, 1)) {
        return this.$t('routs.rules.nameRequired');
      } else {
        return true;
      }
    },
    codIntegracaoRules() {
      const valor = this.editedItem.cod_integracao;
      if (valor === null || valor === undefined || String(valor).length === 0) {
        return true;
      }
      if (!validador(valor, 1, 50, 0, 1)) {
        return this.$t('routs.rules.integrationCodeInvalid');
      }
      return true;
    },
    observacoesRules() {
      if (this.editedItem.observacoes === null || this.editedItem.observacoes.length === 0) {
        return true;
      }

      if (!validador(this.editedItem.observacoes, 1, 10000, 1, 0)) {
        return this.$t('routs.rules.observationsRequired');
      } else {
        return true;
      }
    },
    geojsonRules() {
      if (!this.editedItem.geojson && !this.editedItem.shape && !this.arquivoGeojson) {
        return this.$t('routs.geometryRequired');
      }

      return true;
    },
    contagemVerticesRota() {
      try {
        if (this.editedItem.shape) {
          const pts =
            typeof this.editedItem.shape === "string"
              ? JSON.parse(this.editedItem.shape)
              : this.editedItem.shape;
          if (Array.isArray(pts)) return pts.length;
        }
        const gj =
          typeof this.editedItem.geojson === "string"
            ? JSON.parse(this.editedItem.geojson)
            : this.editedItem.geojson;
        const coords = this.getLineStringCoordinates(gj);
        return coords ? coords.length : 0;
      } catch (e) {
        return 0;
      }
    },
    clientesFiltrados() {
      if (!this.editedItem.id_empresa) {
        return [];
      }
      return this.clientes.filter(
        (c) => c.id_empresa === this.editedItem.id_empresa && (c.ativo === 1 || c.ativo === true)
      );
    },
    headersCSV() {
      return [
        { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
        { text: this.$t('crudVeiculos.csvHeaders.operacao'), value: 'operacao' },
        { text: this.$t('routs.headers.company'), value: 'empresa' },
        { text: this.$t('routs.headers.clientCode'), value: 'cod_cliente' },
        { text: this.$t('routs.headers.code'), value: 'cod_rota' },
        { text: this.$t('routs.headers.name'), value: 'nome_rota' },
        { text: this.$t('routs.headers.integrationCode'), value: 'cod_integracao' },
        { text: this.$t('routs.headers.distance'), value: 'distancia' },
        { text: this.$t('routs.headers.active'), value: 'ativa' },
        { text: this.$t('routs.headers.observations'), value: 'observacoes' },
        { text: this.$t('routs.headers.shape'), value: 'shape' },
        { text: this.$t('routs.headers.geojson'), value: 'geojson' }];
    },
    helpCSV() {
      return [
        { label: this.$t('routs.headers.company'), description: this.$t('routs.csvHelp.empresa'), example: "Empresa XYZ", key: "empresa" },
        { label: this.$t('routs.headers.clientCode'), description: this.$t('routs.csvHelp.codCliente'), example: "CLI001", key: "cod_cliente" },
        { label: this.$t('routs.headers.code'), description: this.$t('routs.csvHelp.codRota'), example: "RT-001", key: "cod_rota" },
        { label: this.$t('routs.headers.name'), description: this.$t('routs.csvHelp.nomeRota'), example: "Rota Centro", key: "nome_rota" },
        { label: this.$t('routs.headers.distance'), description: this.$t('routs.csvHelp.distancia'), example: "15.5", key: "distancia" },
        { label: this.$t('routs.headers.active'), description: this.$t('routs.csvHelp.ativa'), example: "1", key: "ativa" },
        { label: this.$t('routs.headers.observations'), description: this.$t('routs.csvHelp.observacoes'), example: "Rota principal", key: "observacoes" },
        { label: this.$t('routs.headers.shape'), description: this.$t('routs.csvHelp.shape'), example: "[{\"lt\":-22.9,\"lg\":-43.2}]", key: "shape" },
        { label: this.$t('routs.headers.geojson'), description: this.$t('routs.csvHelp.geojson'), example: "{...}", key: "geojson" },
        { label: this.$t('routs.headers.integrationCode'), description: this.$t('routs.csvHelp.codIntegracao'), example: "INT001", key: "cod_integracao" }];
    },
    exportDialogHeaders() {
      return [
        { text: this.$t('routs.headers.code'), value: 'cod_rota' },
        { text: this.$t('routs.headers.name'), value: 'nome_rota' },
        { text: this.$t('routs.headers.company'), value: 'empresa' },
        { text: this.$t('routs.headers.distance'), value: 'distancia' },
        { text: this.$t('routs.headers.active'), value: 'ativa_extenso' },
      ];
    },
    rotasForExportDialog() {
      return this.rotasExportDialogItems || [];
    },
  },
  watch: {
    selecionadas(list, prev) {
      // MerusDataTable emite `input` duas vezes por mudança: compara por chave.
      if (sameSelection(list, prev, "id_rota")) return;
      this.parametrosPage = 0;
    },
    itemParametrosAtual(item, prev) {
      const atual = item && item.id_rota;
      const anterior = prev && prev.id_rota;
      if (String(atual) === String(anterior)) return;
      this.selecionarRota(item || null);
    },
    mostrarInativos() {
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    idLinhaSelected() {
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    dialog(val) {
      if (val && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    clientes() {
      if (this.dialog && this.editedIndex === -1) {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
      }
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    '$i18n.locale'() {
      this.initialize();
      const form = this.$refs.formCreate || this.$refs.formParametros;
      if (form && typeof form.resetValidation === "function") {
        form.resetValidation();
      }
    },
    'editedItem.id_empresa'() {
      if (this.editedItem.id_cliente == null) {
        return;
      }
      const ok = this.clientesFiltrados.some((c) => c.id_cliente === this.editedItem.id_cliente);
      if (!ok) {
        this.editedItem.id_cliente = null;
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();

  },
  mounted() { },
  methods: {

    onLinhaFiltroInput(val) {
      this.idLinhaSelected = val;
    },
    columnFiltersOnly() {
      const baseKeys = { somente_ativas: true, id_linha: true };
      const out = {};
      Object.keys(this.searchFilters || {}).forEach((k) => {
        if (!baseKeys[k]) out[k] = this.searchFilters[k];
      });
      return out;
    },
    serverTableBaseFilters() {
      const base = {};
      if (!this.mostrarInativos) base.somente_ativas = '1';
      if (this.idLinhaSelected) base.id_linha = String(this.idLinhaSelected);
      return base;
    },
    /** Reaponta a seleção para os objetos da página sem perder marcados em outras páginas. */
    resyncAposReload() {
      this.selecionadas = mergeSelectionWithPage(this.selecionadas, this.rotas, "id_rota");
      const item = this.itemParametrosAtual;
      if (item) {
        this.rotaSelecionada = item;
        this.loadParametrosRota(item);
      }
    },
    onMapAction({ action, geometry, active } = {}) {
      if (action === "create-route") {
        this.startCreateRota();
        return;
      }
      if (action === "close-create") {
        this.close({ fromMap: true });
        return;
      }
      if (action === "draw-route-mode") {
        this.desenhoRotaAtivo = !!active;
        return;
      }
      if (action === "route-line-draft") {
        this.aplicarGeometriaDoMapa(geometry, { preview: false });
        return;
      }
      if (action === "route-line-drawn") {
        this.aplicarGeometriaDoMapa(geometry, { preview: true });
      }
    },
    aplicarGeometriaDoMapa(geometry, { preview = true } = {}) {
      if (!geometry || typeof geometry !== "object") return;
      const shape =
        geometry.shape == null
          ? null
          : typeof geometry.shape === "string"
            ? geometry.shape
            : JSON.stringify(geometry.shape);
      const geojson =
        geometry.geojson == null
          ? null
          : typeof geometry.geojson === "string"
            ? geometry.geojson
            : JSON.stringify(geometry.geojson);
      this.$set(this.editedItem, "shape", shape);
      this.$set(this.editedItem, "geojson", geojson);
      if (geometry.distancia != null && geometry.distancia !== "") {
        this.$set(this.editedItem, "distancia", geometry.distancia);
      }
      if (preview && (geojson || shape)) {
        const split = this.$refs.detalheSplit;
        if (split && typeof split.previewAndFocusRota === "function") {
          split.previewAndFocusRota(
            {
              ...this.editedItem,
              geojson,
              shape,
            },
            { focus: true },
          );
        }
      }
    },
    toggleDesenhoRota() {
      const split = this.$refs.detalheSplit;
      const next = !this.desenhoRotaAtivo;
      if (split && typeof split.setDrawRouteMode === "function") {
        split.setDrawRouteMode(next);
      }
    },
    limparGeometriaRotaFormulario() {
      this.$set(this.editedItem, "shape", null);
      this.$set(this.editedItem, "geojson", null);
      this.arquivoGeojson = null;
      const split = this.$refs.detalheSplit;
      if (split && typeof split.setDrawRouteMode === "function") {
        split.setDrawRouteMode(false);
      }
      if (split && typeof split.clearCreateDraftRota === "function") {
        split.clearCreateDraftRota();
      }
    },
    startCreateRota() {
      this.scopedClienteCreateLocked = false;
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.isAtivo = true;
      this.arquivoGeojson = null;
      this.desenhoRotaAtivo = false;
      this.createValidationAttempted = false;
      this.dialog = true;
      this.$nextTick(() => {
        const form = this.$refs.formCreate;
        if (form && typeof form.resetValidation === "function") form.resetValidation();
        const split = this.$refs.detalheSplit;
        if (split && typeof split.openCreateDrawer === "function") {
          split.openCreateDrawer({ silent: true });
        }
      });
    },
    /** Traçado alterado por edição in-place no mapa de preview. */
    onPreviewChanged({ item } = {}) {
      if (!item || item.id_rota == null) return;
      const row = this.rotas.find((r) => Number(r.id_rota) === Number(item.id_rota));
      if (row) Object.assign(row, item);
      this.resyncAposReload();
    },
    selecionarRota(item) {
      this.rotaSelecionada = item || null;
      this.preferredRouteIds = item && item.id_rota != null ? [Number(item.id_rota)] : [];
      if (!item) {
        this.linhaSelecionada = null;
        this.editedIndex = -1;
        return;
      }
      this.loadParametrosRota(item);
      this.initialDetailTab = 0;
      this.linhaSelecionada = null;
    },
    async loadParametrosRota(item) {
      this.scopedClienteCreateLocked = false;
      this.editedIndex = item && item.id_rota != null ? 0 : -1;
      let full = Object.assign({}, item);
      if (item && item.id_rota != null && !item.shape && !item.geojson) {
        try {
          const res = await apiController.request(apiController.endpoints.getRotaporid, {
            params: { id: item.id_rota },
            silent: true,
          });
          const row = Array.isArray(res.data) ? res.data[0] : res.data;
          if (row) full = Object.assign({}, item, row);
        } catch (e) {
          /* preview sem geometria */
        }
      }
      this.editedItem = full;
      this.isAtivo = Number(this.editedItem.ativa) === 1;
      if (this.editedItem.geojson) {
        try {
          this.plotOnMap(JSON.parse(this.editedItem.geojson));
        } catch (e) {
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectFormat') });
        }
      }
    },
    saveParametros() {
      this.save();
    },
    _buildRoutesFeatureCollection(routes, timestamp) {
    return {
      type: "FeatureCollection",
      name: `rotas-${timestamp}`,
      features: routes
        .map((rota) => {
          if (!rota.geojson) {
            return null;
          }

          try {
            const geojson =
              typeof rota.geojson === "string"
                ? JSON.parse(rota.geojson)
                : rota.geojson;

            const feature = this.normalizeGeojsonFeature(geojson);

            if (!feature) {
              return null;
            }

            feature.properties = {
              ...feature.properties,
              id_rota: rota.id_rota,
              cod_rota: rota.cod_rota,
              nome_rota: rota.nome_rota,
              empresa: rota.razao_social,
              distancia: rota.distancia,
            };

            return feature;
          } catch (e) {
            return null;
          }
        })
        .filter(Boolean),
    };
  },
  
  _buildRoutesExportTimestamp() {
    const date = new Date();

    return (
      date.getFullYear() +
      String(date.getMonth() + 1).padStart(2, "0") +
      String(date.getDate()).padStart(2, "0") +
      String(date.getHours()).padStart(2, "0") +
      String(date.getMinutes()).padStart(2, "0") +
      String(date.getSeconds()).padStart(2, "0")
    );
  },
  
  _downloadTextFile(content, mimeType, fileName) {
    const blob = new Blob([content], { type: mimeType });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();

    URL.revokeObjectURL(url);
  },

  onConfirmExportRoutes() {
    this.exportRoutes(this.exportRoutesFormat);
    this.closeExportRoutesDialog();
  },

  async openExportRoutesDialog() {
    if (!this.selecionadas.length) {
      EventBus.$emit('show-alert', {
        tipo: 'warning',
        mensagem: this.$t('routs.alerts.error.noRoutesSelected'),
      });
      return;
    }
    this.exportRoutesFormat = 'geojson';
    this.showExportRoutesDialog = true;
    this.loadingExportDialog = true;
    try {
      const ids = this.selecionadas
        .map((r) => (r && r.id_rota != null ? r.id_rota : null))
        .filter((id) => id != null);
      const rows = await Promise.all(
        ids.map(async (id) => {
          const source = this.selecionadas.find((r) => Number(r.id_rota) === Number(id));
          if (source && (source.shape || source.geojson)) return source;
          try {
            const res = await apiController.request(apiController.endpoints.getRotaporid, {
              params: { id },
              silent: true,
            });
            const row = Array.isArray(res.data) ? res.data[0] : res.data;
            return row ? Object.assign({}, source, row) : source;
          } catch (e) {
            return source;
          }
        })
      );
      this.rotasExportDialogItems = rows
        .filter(Boolean)
        .map((r) => ({ ...r, empresa: r.razao_social || r.empresa }));
      // Pré-marcadas por padrão (decisão do usuário).
      this.rotasSelected = this.rotasExportDialogItems.slice();
    } catch (e) {
      this.rotasExportDialogItems = [];
      this.rotasSelected = [];
      EventBus.$emit('show-error', { error: e });
    } finally {
      this.loadingExportDialog = false;
    }
  },

  closeExportRoutesDialog() {
    this.showExportRoutesDialog = false;
    this.rotasSelected = [];
  },

  exportRoutes(format = 'geojson', routes = null, fileNamePrefix = null) {
    const routesToExport = routes || this.rotasSelected;
    if (!routesToExport || routesToExport.length === 0) {
      EventBus.$emit('show-alert', {
        tipo: 'warning',
        mensagem: this.$t('routs.alerts.error.noRoutesSelected'),
      });
      return;
    }
    const timestamp = this._buildRoutesExportTimestamp();
    const featureCollection = this._buildRoutesFeatureCollection(routesToExport, timestamp);
    if (!featureCollection.features.length) {
      EventBus.$emit('show-alert', {
        tipo: 'warning',
        mensagem: this.$t('routs.alerts.error.noRouteGeometry'),
      });
      return;
    }
    const prefix = fileNamePrefix || `rotas-${timestamp}`;
    if (format === 'kml') {
      const kml = featureCollectionToKml(featureCollection);
      this._downloadTextFile(
        kml,
        'application/vnd.google-earth.kml+xml',
        `${prefix}.kml`,
      );
      return;
    }
    const geojsonStr = JSON.stringify(featureCollection, null, 2);
    this._downloadTextFile(geojsonStr, 'application/geo+json', `${prefix}.geojson`);
  },

  getLineStringCoordinates(geojson) {
      if (!geojson) {
        return null;
      }

      if (geojson.type === 'LineString' && Array.isArray(geojson.coordinates)) {
        return geojson.coordinates;
      }

      if (geojson.geometry && geojson.geometry.type === 'LineString' && Array.isArray(geojson.geometry.coordinates)) {
        return geojson.geometry.coordinates;
      }

      if (geojson.type === 'FeatureCollection' && Array.isArray(geojson.features)) {
        const lineFeature = geojson.features.find(f => f.geometry && f.geometry.type === 'LineString' && Array.isArray(f.geometry.coordinates));
        return lineFeature ? lineFeature.geometry.coordinates : null;
      }

      return null;
    },
    normalizeGeojsonFeature(geojson) {
      if (!geojson) {
        return null;
      }

      if (geojson.type === 'FeatureCollection' && Array.isArray(geojson.features)) {
        const lineFeature = geojson.features.find(f => f.geometry && f.geometry.type === 'LineString');
        return lineFeature ? { ...lineFeature, properties: lineFeature.properties || {} } : null;
      }

      if (geojson.type === 'LineString' && Array.isArray(geojson.coordinates)) {
        return {
          type: 'Feature',
          properties: {},
          geometry: geojson,
        };
      }

      if (geojson.geometry && geojson.geometry.type === 'LineString') {
        return {
          ...geojson,
          properties: geojson.properties || {},
        };
      }

      return null;
    },
    isCodRotaValid(value) {
      if (!value) {
        return false;
      }

      return /^[a-zA-Z0-9_ -]{1,50}$/.test(value);
    },
    compactExportJsonField(value) {
      if (!value) {
        return value;
      }

      try {
        return JSON.stringify(typeof value === "string" ? JSON.parse(value) : value);
      } catch (e) {
        return String(value).replace(/\r?\n|\r/g, " ");
      }
    },
    initialize() {
      if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
        const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
        this.serverSortBy = serverSortBy;
        this.serverSortDesc = serverSortDesc;
      }
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.getConfig();
      this.populaPermissoes();
      this.populaRecursos();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
        },
      });
    },
    populaPermissoes() {
      apiController.request(apiController.endpoints.getPermissoesusuario, {
        params: { id: this.user.id_usuario },
        onSuccess: (response) => {
          this.permissoes = response.data;
        },
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.canEditLinha = true;
            this.populaRotas();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updaterota");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertrota");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleterota");
            this.canEditLinha = this.recursos.some((r) => r.rota === "/api/v1.0/updatelinha");
            this.populaRotas();
          },
        });
      }
    },
    populaRotas() {
      this.serverTableLoad();
      this.populaEmpresas();
      this.populaClientes();
    },
    serverTableLoad(options) {
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalRotas,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      apiController.request(apiController.endpoints.getallRotas, {
        data: params,
        onSuccess: (response) => {
          const data = response.data;
          const totalNum = data && data.total != null && data.total !== '' ? Number(data.total) : NaN;
          const mapRows = (rows) => (rows || []).map((r) => ({ ...r, empresa: r.razao_social || r.empresa }));
          if (data && !Number.isNaN(totalNum) && Array.isArray(data.items)) {
            this.rotas = mapRows(data.items);
            const updates = computePageState(
              { items: data.items, total: totalNum },
              { page, rowsPerPage, sortByArr, sortDescArr },
              state,
              this.itemsPerPageLastOption
            );
            this.totalRotas = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            this.rotas = mapRows(Array.isArray(data) ? data : []);
            this.totalRotas = this.rotas.length;
          }
          this.loadingtable = false;
          this.$nextTick(() => this.resyncAposReload());
        },
        onError: (e) => {
          this.loadingtable = false;
          console.log("ERRO AXIOS");
          console.log(e);
        },
      });
    },
    mapForExport(rows) {
      return (rows || []).map((rota) => {
        const empresa = rota.empresa || rota.razao_social || "";
        const cod_cliente = rota.cliente_codigo || rota.codigo_cliente || "";
        return {
          ...rota,
          empresa,
          cod_cliente,
          razao_social: rota.razao_social || rota.empresa || "",
          shape: this.compactExportJsonField(rota.shape),
          geojson: this.compactExportJsonField(rota.geojson),
        };
      });
    },
    async loadItemsForExport(onProgress) {
      const selected = this.selecionadas;
      if (selected && selected.length > 0) {
        if (typeof onProgress === "function") onProgress(100);
        return this.mapForExport(selected.slice());
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallRotas,
            { data: Object.assign({}, params, { incluir_geometria: '1' }), silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalRotas,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        mapItems: (items) => this.mapForExport(items),
        onProgress,
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = (response.data || []).map((c) => ({
            ...c,
            labelCliente: [c.codigo_cliente, c.nome_cliente].filter(Boolean).join(" — "),
          }));
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e);
        },
      });
    },
    applyScopedClienteEmpresaOnCreate() {
      this.scopedClienteCreateLocked = false;
      if (this.editedIndex !== -1 || !shouldLockClienteOnCreate()) {
        return;
      }
      const id = getScopedClienteIdForCreate();
      if (id == null) {
        return;
      }
      const c = this.clientes.find((x) => Number(x.id_cliente) === Number(id));
      if (!c || c.id_empresa == null) {
        return;
      }
      this.editedItem.id_cliente = id;
      this.editedItem.id_empresa = c.id_empresa;
      this.scopedClienteCreateLocked = true;
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1) {
        return;
      }
      if (this.scopedClienteCreateLocked) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('routs.deactivateRoute') + " " + item.cod_rota + " ?";
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      const deletedId = this.deletedItem && this.deletedItem.id_rota;
      apiController.request(apiController.endpoints.deleteRota, {
        data: this.deletedItem,
        onSuccess: (response) => {
          if (deletedId != null) {
            this.selecionadas = dropFromSelection(this.selecionadas, [deletedId], "id_rota");
          }
          this.updateTable(response.data.erro);
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e);
        },
      });
    },
    close({ fromMap } = {}) {
      this.dialog = false;
      this.desenhoRotaAtivo = false;
      const split = this.$refs.detalheSplit;
      if (split && typeof split.setDrawRouteMode === "function") {
        split.setDrawRouteMode(false);
      }
      if (split && typeof split.clearCreateDraftRota === "function") {
        split.clearCreateDraftRota();
      }
      if (!fromMap && split && typeof split.closeCreateDrawer === "function") {
        split.closeCreateDrawer({ silent: true });
      }
      this.$nextTick(() => {
        this.scopedClienteCreateLocked = false;
        this.createValidationAttempted = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isAtivo = true;
        this.arquivoGeojson = null;
        const form = this.$refs.formCreate;
        if (form && typeof form.resetValidation === "function") form.resetValidation();
        const item = this.itemParametrosAtual;
        if (item) this.loadParametrosRota(item);
      });
    },
    buildShape(geojson) {
      try {
        const coordinates = this.getLineStringCoordinates(geojson);
        if (coordinates) {
          return JSON.stringify(coordinates.map(c => {
            return {
              lt: c[1],
              lg: c[0]
            }
          }));
        }

        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectGeometry') + (geojson.geometry?.type || geojson.type || geojson.features?.[0]?.geometry?.type || '') });
        return null;
      } catch (e) {
        console.log("ERRO AXIOS");
        console.log(e);
        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectShape') });
        return null;
      }
    },
    getRouteEndpoints(shape) {
      try {
        const points = typeof shape === 'string' ? JSON.parse(shape) : shape;
        if (!Array.isArray(points) || points.length < 1) {
          return null;
        }
        const start = points[0];
        const end = points[points.length - 1];
        if (
          start == null || end == null ||
          start.lt == null || start.lg == null ||
          end.lt == null || end.lg == null
        ) {
          return null;
        }
        return {
          start: { lat: Number(start.lt), lng: Number(start.lg) },
          end: { lat: Number(end.lt), lng: Number(end.lg) },
        };
      } catch (e) {
        return null;
      }
    },
    buildEndpointFences(rota) {
      const endpoints = this.getRouteEndpoints(rota.shape);
      if (!endpoints) {
        return null;
      }
      const raio = Number(this.config && this.config.raio_cerca_padrao) > 0
        ? Number(this.config.raio_cerca_padrao)
        : 50;
      const idEmpresa = rota.id_empresa != null && rota.id_empresa !== '' ? rota.id_empresa : null;
      const idCliente = rota.id_cliente != null && rota.id_cliente !== '' ? rota.id_cliente : null;
      const makeFence = (point, suffix) => ({
        cod_cerca: `${String(rota.cod_rota || '').substring(0, 48)}${suffix}`,
        nome_cerca: `${String(rota.nome_rota || '').substring(0, 198)}${suffix}`,
        alarme_entrada: 0,
        alarme_saida: 0,
        endereco: null,
        shape: null,
        lat_centro: point.lat,
        lng_centro: point.lng,
        alarme_velocidade: 0,
        velocidade_maxima: null,
        geojson: null,
        is_circular: 1,
        raio_mts: raio,
        observacoes: null,
        id_empresa: idEmpresa,
        id_cliente: idCliente,
      });
      return [
        makeFence(endpoints.start, 'CI'),
        makeFence(endpoints.end, 'CF'),
      ];
    },
    createEndpointFences(rota, onDone) {
      const fences = this.buildEndpointFences(rota);
      if (!fences) {
        onDone(false);
        return;
      }
      apiController.request(apiController.endpoints.insertCercasbulk, {
        data: fences,
        silent: true,
        onSuccess: (response) => {
          onDone(!(response.data && response.data.erro));
        },
        onError: () => {
          onDone(false);
        },
      });
    },
    save() {
      if (this.dialog) this.createValidationAttempted = true;
      const split = this.$refs.detalheSplit;
      if (split && typeof split.finalizeDrawRouteIfPending === "function") {
        split.finalizeDrawRouteIfPending();
      }
      const form = this.dialog ? this.$refs.formCreate : this.$refs.formParametros;
      if (form) form.validate();
      if (this.formValidado) {
        if (this.isAtivo) {
          this.editedItem.ativa = 1;
        } else {
          this.editedItem.ativa = 0;
        }

        let geojsonObj = null;
        try {
          geojsonObj =
            typeof this.editedItem.geojson === "string"
              ? JSON.parse(this.editedItem.geojson)
              : this.editedItem.geojson;
        } catch (e) {
          geojsonObj = null;
        }
        if (!geojsonObj && this.editedItem.shape) {
          try {
            const pts =
              typeof this.editedItem.shape === "string"
                ? JSON.parse(this.editedItem.shape)
                : this.editedItem.shape;
            if (Array.isArray(pts) && pts.length >= 2) {
              geojsonObj = {
                type: "Feature",
                properties: {},
                geometry: {
                  type: "LineString",
                  coordinates: pts.map((p) => [Number(p.lg), Number(p.lt)]),
                },
              };
              this.editedItem.geojson = JSON.stringify(geojsonObj);
            }
          } catch (e) {
            geojsonObj = null;
          }
        }
        if (!geojsonObj) {
          EventBus.$emit('show-alert', {
            tipo: 'error',
            mensagem: this.$t('routs.geometryRequired'),
          });
          return;
        }
        this.editedItem.shape = this.buildShape(geojsonObj);

        if (!this.editedItem.shape) {
          return;
        }

        this.editedItem.cod_integracao =
          this.editedItem.cod_integracao != null
            && String(this.editedItem.cod_integracao).trim() !== ""
            ? String(this.editedItem.cod_integracao).trim()
            : null;

        if (this.editedItem.id_rota == null) {
          this.operacao = 0;
          this.editedIndex = -1;
          apiController.request(apiController.endpoints.insertRota, {
            data: this.editedItem,
            onSuccess: (response) => {
              if (response.data.erro) {
                this.updateTable(response.data.erro);
                return;
              }
              this.createEndpointFences(this.editedItem, (fencesOk) => {
                this.updateTable(false);
                if (!fencesOk) {
                  this.$nextTick(() => {
                    EventBus.$emit('show-alert', {
                      tipo: 'warning',
                      mensagem: this.$t('routs.alerts.warning.endpointFences'),
                    });
                  });
                }
              });
            },
            onError: (e) => {
              console.log("ERRO AXIOS");
              console.log(e);
            },
          });
        } else {
          this.operacao = 1;
          this.editedIndex = 0;
          apiController.request(apiController.endpoints.updateRota, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
            onError: (e) => {
              console.log("ERRO AXIOS");
              console.log(e);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      let tipo = status ? "error" : "success";
      
      if (status) {
        if (this.operacao == 0) {
          mensagem = this.$t('routs.alerts.error.insert');
        } else if (this.operacao == 1) {
          mensagem = this.$t('routs.alerts.error.update');
        } else if (this.operacao == 3) {
          mensagem = this.$t('routs.alerts.error.insert_bulk');
        } else {
          mensagem = this.$t('routs.alerts.error.delete');
        }
      } else {
        if (this.operacao == 0) {
          mensagem = this.$t('routs.alerts.success.insert');
        } else if (this.operacao == 1) {
          mensagem = this.$t('routs.alerts.success.update');
        } else if (this.operacao == 3) {
          mensagem = this.$t('routs.alerts.success.insert_bulk');
        } else {
          mensagem = this.$t('routs.alerts.success.delete');
        }
      }
      
      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.initialize();
    },
    saveBulk(result) {
      this.operacao = 3;
      apiController.request(apiController.endpoints.upsertRotasbulk, {
        data: result,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    tryParseGeojsonFromText(content) {
      const text = (content || '').trim();
      if (!text.startsWith('{')) {
        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectFormat') });
        return null;
      }
      try {
        const gjson = JSON.parse(text);
        if (this.getLineStringCoordinates(gjson)) {
          return gjson;
        }
        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectGeometry') + (gjson.geometry?.type || gjson.type || gjson.features?.[0]?.geometry?.type || '') });
        return null;
      } catch (err) {
        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectFormat') });
        return null;
      }
    },
    processaGeojson() {
      const file = Array.isArray(this.arquivoGeojson) ? this.arquivoGeojson[0] : this.arquivoGeojson;
      if (!file) {
        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('system.messages.fileRequired') });
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const gjson = this.tryParseGeojsonFromText(e.target.result);
        if (gjson) {
          const split = this.$refs.detalheSplit;
          if (split && typeof split.setDrawRouteMode === "function") {
            split.setDrawRouteMode(false);
          }
          this.plotOnMap(gjson);
          EventBus.$emit('show-alert', { tipo: 'success', mensagem: this.$t('routs.alerts.success.geojsonLoaded') });
        }
      };
      reader.onerror = () => {
        EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('routs.alerts.error.incorrectFormat') });
      };
      reader.readAsText(file, 'utf8');
    },
    plotOnMap(gjson) {
      if (!gjson) return;
      const feature = this.normalizeGeojsonFeature(gjson);
      if (!feature) {
        EventBus.$emit('show-alert', {
          tipo: 'error',
          mensagem: this.$t('routs.alerts.error.incorrectGeometry') + (gjson.geometry?.type || gjson.type || gjson.features?.[0]?.geometry?.type || ''),
        });
        return;
      }
      this.editedItem.geojson = JSON.stringify(gjson);
      const shape = this.buildShape(gjson);
      if (shape) this.editedItem.shape = shape;
      const split = this.$refs.detalheSplit;
      if (split && typeof split.previewAndFocusRota === "function") {
        split.previewAndFocusRota(
          {
            ...this.editedItem,
            geojson: this.editedItem.geojson,
            shape: this.editedItem.shape,
          },
          { focus: true },
        );
      }
    },
  },
};
</script>
